__turbopack_context__.v({
  "container": "jobBulletpoints-module-scss-module__PfiAUW__container",
  "content": "jobBulletpoints-module-scss-module__PfiAUW__content",
  "icon": "jobBulletpoints-module-scss-module__PfiAUW__icon",
  "iconWrapper": "jobBulletpoints-module-scss-module__PfiAUW__iconWrapper",
  "text": "jobBulletpoints-module-scss-module__PfiAUW__text",
});
